/**
 * Controller: GroupsUsersAddModal
 */
angular.module('acme.view.application.groups.users.addModal.controllers', [
  'acme.common.service.api',
  'acme.common.service.helpers'
])
.controller('GroupsUsersAddModalController', [ '$scope', '$uibModalInstance', 'ApiService', 'HelpersService', 'groupData', 'groupUsers', function ($scope, $uibModalInstance, ApiService, HelpersService, groupData, groupUsers) {

    $scope.errors = [];

    $scope.model = [];

    $scope.query = '';

    $scope.init = function() {

      ApiService.userProxy.list(HelpersService.getPaginator()).then(function(response) {
        var i, ii,
            j, jj,
            users = response.data.payload.list;

        for (i=0,ii=users.length;i<ii;i++) {
          for (j=0,jj=groupUsers.length;j<jj;j++) {
            if (users[i].id === groupUsers[j].id) {
              users[i].selected = true;
              break;
            }
          }
        }

        $scope.model = users;

      }, function(response) {
        // TODO: Backfill
      });

    };

    $scope.checkQuery = function(user, query) {
      var q = '';
      if (user.firstName) {
        q += user.firstName;
      }
      if (user.lastName) {
        q += user.lastName;
      }
      if (user.email) {
        q += user.email;
      }
      q = q.toLowerCase();

      console.log('GroupsUsersAddModalController::search', query);
      return (q.indexOf(query) === -1);
    };

    $scope.hasErrors = function() {
      return ($scope.errors.length > 0);
    };

    $scope.getSelected = function() {
      var i, ii,
          users = [],
          mappings = [];

      // Returns only the relationship between user and group
      for (i=0,ii=$scope.model.length;i<ii;i++) {
        if ($scope.model[i].selected) {
          users.push($scope.model[i]);
          mappings.push({
            userId: $scope.model[i].id,
            userGroupId: groupData.id
          });
        }
      }

      return { mappings: mappings, users: users };
    };

    $scope.done = function() {
      $scope.success();
    };

    $scope.cancel = function () {
      $uibModalInstance.dismiss('cancel');
    };

    $scope.success = function () {
      $uibModalInstance.close($scope.getSelected());
    };

    $scope.init();

}]);